import React from "react";
import { useLocalizedStrings } from "../Localization";

const Footer = () => {
  const strings  = useLocalizedStrings();

  return (
    <div className="grid grid-cols-1 w-full border-4 border-black rounded-md px-8 py-2 bg-[#FBF3B9] shadow-md">
        <p 
          className="md:text-4xl text-sm italic font-bold m-auto py-4"
          style={{ fontFamily: 'Grape Nuts' }}
        >
            {strings.footerMessage}
        </p>
        <p className="md:text-lg text-sm m-auto italic">{strings.copyright}</p>
    </div>
  );
};

export default Footer;
